import React, { useEffect, useState } from 'react'
import { useWebsiteBannersList } from './hooks'
import { CButton, CCardBody } from '@coreui/react-pro'
import { path } from '../../../../../libs'
import { Table, Tag } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import CIcon from '@coreui/icons-react'
import { cilZoom } from '@coreui/icons'
import { OfferLink, WebsiteBannerFile, WebsiteBannerItem } from './types'
import { FilterValue, Key } from 'antd/es/table/interface'
import { languagesForFilter } from '../../../../../libs/languages'

export const WebsiteBannersList: React.FC = () => {
  const {
    websiteBannerItems,
    totalCountOfWebsiteBannerItems,
    onChangeWebsiteBannersList,
    loading,
  } = useWebsiteBannersList()

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [filtersState, setFiltersState] = useState<
    Record<string, FilterValue | null>
  >({})

  const handleTableChange = ({
    currentPage,
    currentPageSize,
    filters,
  }: {
    currentPage?: number
    currentPageSize?: number
    filters?: Record<string, FilterValue | null>
  }) => {
    if (currentPage) {
      setPage(currentPage)
    }
    if (currentPageSize) {
      setPageSize(currentPageSize)
    }
    if (filters) {
      setFiltersState(filters)
    }
  }

  useEffect(() => {
    onChangeWebsiteBannersList({
      limit: pageSize,
      page: page,
      filters: filtersState,
    })
  }, [pageSize, page, filtersState])

  const columns: ColumnsType<WebsiteBannerItem> = [
    {
      title: 'ID',
      dataIndex: 'id',
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: 'descend',
    },
    {
      title: 'Name',
      dataIndex: 'title',
      key: 'title',
      sorter: true,
    },
    {
      title: 'Language',
      dataIndex: 'lang',
      key: 'lang',
      filters: languagesForFilter,
      filterSearch: true,
      onFilter: (value: boolean | Key, record) => record.lang === value,
    },
    {
      title: 'Offer',
      dataIndex: 'offer',
      render: (offer) => {
        return <div>{offer.title}</div>
      },
    },
    {
      title: 'Files',
      dataIndex: 'websiteBannerFiles',
      render: (files: WebsiteBannerFile[]) => {
        return <div>{files.length}</div>
      },
    },
    {
      title: 'Status',
      dataIndex: 'isVisible',
      filters: [
        { text: 'Active', value: true },
        { text: 'Inactive', value: false },
      ],
      filterMultiple: false,
      render: (status: boolean) => {
        return (
          <Tag color={status ? 'success' : 'error'}>
            {status ? 'Active' : 'Inactive'}
          </Tag>
        )
      },
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 100,
      render: (item) => {
        return (
          <>
            <CButton
              color="secondary"
              className="me-2"
              title="View"
              href={path.ib.ad.banners.edit(item.id)}
            >
              <CIcon icon={cilZoom} />
            </CButton>
          </>
        )
      },
    },
  ]

  return (
    <CCardBody>
      <CButton
        color="primary"
        className="mb-2"
        href={path.ib.ad.banners.create()}
      >
        Create website banner
      </CButton>
      <Table
        dataSource={websiteBannerItems}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        rowKey="websiteBannersTable"
        columns={columns}
        pagination={{
          showSizeChanger: true,
          total: totalCountOfWebsiteBannerItems,
        }}
        onChange={(pagination, filters, sorter) =>
          handleTableChange({
            //@ts-ignore
            currentPage: pagination.current, //@ts-ignore
            currentPageSize: pagination.pageSize, //@ts-ignore
            currentOrderDirection: sorter.order, //@ts-ignore
            currentOrderBy: sorter.field,
            filters,
          })
        }
      ></Table>
    </CCardBody>
  )
}
